import { TablePreferences } from "@/components/chat/types";

import { version } from "../../package.json";

export const STAGE = import.meta.env.VITE_STAGE || "prod";

export const APP_NAME = "NBA Semantic Search";

/** The app's semantic version, sourced from package.json at build time. */
export const APP_VERSION = version;

/** Right-rail drawer identifiers used by the AppLayout drawers API. */
export const HELP_DRAWER_ID = "help";
export const PROCESSING_STEPS_DRAWER_ID = "processing-steps";
export const CLIP_PREVIEW_DRAWER_ID = "clip-preview";

export const EXTERNAL_LINKS = [
  { title: "Iconik", url: "https://app.iconik.io/search" },
  { title: "Q For PVLS", url: "https://q.pvlivesports.com/" },
  { title: "NBA Getty Images", url: "https://www.gettyimages.com" },
  { title: "NBA Content Network", url: "https://content.nba.com" },

  // Future: enable these links when NASCAR and NFL are available.
  // { title: "NASCAR Cam", url: "https://cam.mam.nascar.com/" },
  // { title: "NFL NGS -", url: "https://ngs.nfl.com/home" },
];

export const DEFAULT_PREFERENCES: TablePreferences = {
  pageSize: 50,
  stripedRows: true,
};
